import { CompareTypeAdapter, CompareVariable } from './compare-type-adapter.model';

const VARIABLES: CompareVariable[] = [
  { key: 'strength', labelKey: 'variables.strength', unit: 'MPa', section: 'common' },
  { key: 'maturity', labelKey: 'variables.maturity', unit: 'ºC·day', section: 'common' },
  { key: 'temperature', labelKey: 'variables.temperature', unit: 'ºC', section: 'common' },
];

export const maturityCompareAdapter: CompareTypeAdapter = {
  type: 'MaturityMeasurement',
  selectFields: ['name', 'measurementType', 'time', 'strength', 'maturity', 'temperature'],
  sectionLabelKey: () => 'compare_measurements.sections.common',
  variables: () => VARIABLES,
  buildSeries(m, variable) {
    const values = (m as any)[variable.key];
    const time = (m as any).time;
    if (!Array.isArray(values) || !values.length || !Array.isArray(time) || !time.length) return [];
    return [{ label: m.name as string, time: time.map((x: any) => new Date(x)), values }];
  },
};
